import { Locale } from './src-types-locales.js';
import { PageId } from './src-types-pageId.js';

const SurchargeApplicableLocales = [Locale.enUS, Locale.esUS, Locale.enCA, Locale.frCA];
const SurchargeApplicableCountries = ["US"];
const SurchargeApplicablePageIds = [PageId.LatPDP, PageId.PDP, PageId.CorePDP];

export { SurchargeApplicableCountries, SurchargeApplicableLocales, SurchargeApplicablePageIds };
//# sourceMappingURL=src-types-surcharge.js.map
